import React, { useCallback, useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import messages from "../../../redux/messages";
import { EDITOR_JS_TOOLS } from "../../../components/OnBoarding_OffBoarding/tools";
import { createReactEditorJS } from "react-editor-js";
import { ReactSortable } from "react-sortablejs";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Table,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomNavbar from "../../../components/CustomNavbar";

//redux
import {
  deleteMatrixNineBoxes,
  editMatrixNineBoxes,
  getMatrixNineBoxes,
  saveMatrixNineBoxes,
  saveOrderingboxes,
} from "../../../redux/capacitacionDesarrollo/matrix_nine_boxes/actions";

//css
import "../../../css/capacitacion.css";
import "../../../css/plantillas.css";
import SidebarNueveCajas from "../../../components/nueveCajas/SidebarNueveCajas";

const ReactEditorJS = createReactEditorJS();

const Matrix = () => {
  const fecha = new Date();
  var anioActual = fecha.getFullYear();

  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [validated, setValidated] = useState(false);
  const [_anio, setAnio] = useState(anioActual);
  //
  const editorCore = useRef(null);
  const [list, setList] = useState([]);

  const schema = Yup.object().shape({
    encabezado_cuadrante: Yup.string().ensure().required("**Campo requerido"),
    anio: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(2000, "El valor minimo es 0.")
      .required("**Campo requerido"),
  });

  const dispatch = useDispatch();

  const {
    loaderMatrixNineBoxes,
    matrixNineBoxes,
    matrixNineBoxesAnio,
    matrixNineBoxesFail,
    saveLoaderMatrixNineBoxes,
    matrixNineBoxesFormError,
  } = useSelector((store) => store.matrixNineBoxes);

  //methods
  const _getMatrixNineBoxes = (ani = _anio) =>
    dispatch(
      getMatrixNineBoxes({
        tipo_busqueda: "anio",
        filter: ani,
        // filter_2: ani,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteMatrixNineBoxes(id, data, reOrder, list));
    }
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  useEffect(() => {
    _getMatrixNineBoxes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_anio]);

  useEffect(() => {
    if (matrixNineBoxes) {
      setList(
        matrixNineBoxes.data.sort((a, b) =>
          a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
        )
      );
    }
  }, [matrixNineBoxes]);

  //Orden de X cuando se guarda el registro (cuando se crea el registro)
  const calculateX = () => {
    let valor = 3;
    let countX = 2;
    if (matrixNineBoxes && matrixNineBoxes.data) {
      // eslint-disable-next-line array-callback-return
      matrixNineBoxes.data.map((item, index) => {
        if (valor > 1 && countX < 1) {
          valor = valor - 1;
        }
        if (countX > 0) {
          countX = countX - 1;
        } else {
          countX = 2;
        }
      });
      return valor;
    } else {
      return valor;
    }
  };

  //Orden de Y cuando se guarda el registro (cuando se crea el registro)
  const calculateY = () => {
    let valor = 1;
    //let countY = 0;
    if (matrixNineBoxes && matrixNineBoxes.data) {
      // eslint-disable-next-line array-callback-return
      matrixNineBoxes.data.map((item, index) => {
        if (valor < 3) {
          valor = valor + 1;
        } else {
          valor = 1;
        }
        // if (countY < 2) {
        //   countY = countY + 1;
        // } else {
        //   countY = 0;
        // }
      });
      return valor;
    } else {
      return valor;
    }
  };

  //Metodo para calcular x en el ordenamiento boton guardar orden, unicamente 9 registros
  const calculateXreOrder = (indexOrden) => {
    switch (indexOrden) {
      case 1:
        return 3;

      case 2:
        return 3;

      case 3:
        return 3;

      case 4:
        return 2;

      case 5:
        return 2;

      case 6:
        return 2;

      case 7:
        return 1;

      case 8:
        return 1;

      default:
        return 1;
    }
  };

  //Calcular Y para el boton de reordenamiento boton guardar orden,  unicamente 9 registros
  const calculateYreOrder = (indexOrden) => {
    switch (indexOrden) {
      case 1:
        return 1;

      case 2:
        return 2;

      case 3:
        return 3;

      case 4:
        return 1;

      case 5:
        return 2;

      case 6:
        return 3;

      case 7:
        return 1;

      case 8:
        return 2;

      default:
        return 3;
    }
  };

  const onSubmit = async (req) => {
    if (!edit && matrixNineBoxes && matrixNineBoxes.count === 9) {
      toastr.info("Solo se pueden registrar 9 registros");
      return;
    }
    const savedData = await editorCore.current.save();
    //const dataCarta = { texto_json: savedData.blocks };
    const reqData = {
      encabezado_cuadrante: req.encabezado_cuadrante,
      descripcion_cuadrante: savedData.blocks,
    };
    if (!edit) {
      reqData.x = calculateX();
      reqData.y = calculateY();
      reqData.orden = matrixNineBoxes ? matrixNineBoxes.count + 1 : 1;
      reqData.anio = req.anio;
      dispatch(saveMatrixNineBoxes(reqData, setShowFormModal));
    } else {
      reqData.id = editItem.id;
      dispatch(editMatrixNineBoxes(reqData, index, setShowFormModal));
    }
  };

  //Metodo para ordenar del boton guardar orden
  const reOrder = async (value) => {
    let req = { cajas: [] };

    // eslint-disable-next-line array-callback-return
    value.map((item, index) => {
      console.log("calculate X re order", calculateXreOrder(index));
      req.cajas.push({
        id: item.id,
        x: calculateXreOrder(index + 1),
        y: calculateYreOrder(index + 1),
        orden: index + 1,
      });
    });
    dispatch(saveOrderingboxes(req));
  };

  const handleInitialize = useCallback((instance) => {
    editorCore.current = instance;
  }, []);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarNueveCajas show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">MATRIZ</h5>
            <Form>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      className="rounded-pill mt-0 mr-1"
                      style={{ cursor: "pointer" }}
                      disabled={saveLoaderMatrixNineBoxes}
                      variant="primary"
                      type="button"
                      onClick={() => reOrder(list)}
                    >
                      {saveLoaderMatrixNineBoxes && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          align-items="left"
                        />
                      )}
                      Guardar orden
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Col>
            <Row>
              <Form.Group as={Col} md={5} className="mb-md-1">
                <Row>
                  <Form.Label column sm={3}>
                    Año
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loaderMatrixNineBoxes ? "10" : "12"}>
                        {loaderMatrixNineBoxes ? (
                          <Col sm={1}>
                            <Spinner animation="border" size="sm" />
                          </Col>
                        ) : (
                          <Form.Control
                            as="select"
                            id="aniio"
                            name="aniio"
                            className="col rounded-pill"
                            defaultValue={_anio}
                            disabled={
                              loaderMatrixNineBoxes ||
                              !matrixNineBoxesAnio ||
                              (matrixNineBoxesAnio &&
                                matrixNineBoxesAnio.data.length === 0)
                            }
                            onChange={(e) => {
                              e.preventDefault();
                              setAnio(
                                e.currentTarget.value !== ""
                                  ? parseInt(e.currentTarget.value)
                                  : anioActual
                              );
                            }}
                          >
                            <option
                              className="text-muted"
                              value=""
                              // selected
                              // disabled
                            ></option>
                            {matrixNineBoxesAnio &&
                              matrixNineBoxesAnio.data
                                .sort((a, b) =>
                                  a.anio > b.anio ? 1 : b.anio > a.anio ? -1 : 0
                                )
                                .map((item) => (
                                  <option key={item.anio} value={item.anio}>
                                    {item.anio}
                                  </option>
                                ))}
                          </Form.Control>
                        )}
                      </Col>
                      {/* {loaderMatrixNineBoxes ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null} */}
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
          </Col>
          {!!matrixNineBoxesFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {matrixNineBoxesFail}
            </Alert>
          )}
          {loaderMatrixNineBoxes ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : matrixNineBoxes != null &&
            matrixNineBoxes.data.length > 0 &&
            list.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <Table striped responsive>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Encabezado</th>
                        <th>X</th>
                        <th>Y</th>
                        <th>Cuadrante</th>
                        <th>Fecha de creación</th>
                        <th></th>
                      </tr>
                    </thead>
                    <ReactSortable
                      tag="tbody"
                      list={list}
                      setList={setList}
                      group="matrix"
                      animation={200}
                      handle=".dragI"
                      delayOnTouchOnly={true}
                    >
                      {list.map((item, index) => (
                        <tr key={item.id}>
                          <td style={{ width: "30px" }}>
                            <span className="flex-wrap justify-content-center align-items-center">
                              <i
                                className="material-icons dragI"
                                style={{
                                  color: "##495057",
                                  borderRight: "1px solid #ced4da",
                                }}
                              >
                                drag_indicator
                              </i>
                            </span>
                          </td>
                          <td>{item.encabezado_cuadrante}</td>
                          <td>{item.x}</td>
                          <td>{item.y}</td>
                          <td>{item.orden}</td>
                          <td>
                            {moment(item.fecha_creacion).format("DD/MM/YYYY")}
                          </td>
                          <td>
                            <div className="button-group d-flex" role="group">
                              <Button
                                size="sm"
                                variant="link"
                                type="button"
                                onClick={() => onEdit(item, index)}
                              >
                                <i className="material-icons">edit</i>
                              </Button>
                              <Button
                                size="sm"
                                className="text-danger"
                                variant="link"
                                type="button"
                                onClick={() => onDelete(item.id, index)}
                              >
                                <i className="material-icons">close</i>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </ReactSortable>
                  </Table>
                </Card.Body>
              </Card>
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal
          show={showFormModal}
          onHide={() => setShowFormModal(false)}
          size="lg"
        >
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              encabezado_cuadrante: edit ? editItem.encabezado_cuadrante : "",
              anio: edit ? editItem.anio : anioActual,
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit ? "Editar Matriz" : "Crear Matriz"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {matrixNineBoxesFormError &&
                  typeof matrixNineBoxesFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2 mx-3">
                      {matrixNineBoxesFormError}
                    </Alert>
                  ) : null}
                  {_anio !== anioActual || _anio === "" ? (
                    <Alert variant="info" className="mt-4 mb-2 mx-3">
                      El año seleccionado previamente, debe ser ser igual al año
                      actual.
                    </Alert>
                  ) : null}
                  {!loaderMatrixNineBoxes &&
                  matrixNineBoxes &&
                  matrixNineBoxes.count === 9 &&
                  !edit &&
                  !(_anio !== anioActual || _anio === "") ? (
                    <Alert variant="info" className="mt-4 mb-2 mx-3">
                      La matriz solo puede tener 9 cajas por año.
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Encabezado
                    </Form.Label>
                    <Form.Control
                      name="encabezado_cuadrante"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.encabezado_cuadrante}
                      placeholder="Encabezado"
                      onBlur={handleBlur("encabezado_cuadrante")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.encabezado_cuadrante &&
                        !!errors.encabezado_cuadrante
                      }
                      disabled={
                        _anio !== anioActual ||
                        (!loaderMatrixNineBoxes &&
                          matrixNineBoxes &&
                          matrixNineBoxes.count === 9)
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.encabezado_cuadrante}
                    </Form.Control.Feedback>
                    {matrixNineBoxesFormError &&
                    typeof matrixNineBoxesFormError === "object" &&
                    matrixNineBoxesFormError.encabezado_cuadrante ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {matrixNineBoxesFormError.encabezado_cuadrante.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </Form.Group>

                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Descripción
                    </Form.Label>
                    <div
                      className="
                      flex-wrap
                      justify-content-center
                      align-items-center
                      p-3
                      bg-white
                      "
                    >
                      <Row>
                        <Col
                          className="shadow-sm ml-auto mr-auto p-3 bg-white rounded"
                          style={{ border: "1px solid #ced4da" }}
                          lg="12"
                          xl="12"
                        >
                          {loaderMatrixNineBoxes ||
                          saveLoaderMatrixNineBoxes ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                size="sm"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <ReactEditorJS
                              onInitialize={handleInitialize}
                              onChange={(e) => console.log(e)}
                              defaultValue={
                                edit && !isEmptyObject(editItem)
                                  ? editItem.descripcion_cuadrante &&
                                    editItem.descripcion_cuadrante.length > 0
                                    ? { blocks: editItem.descripcion_cuadrante }
                                    : { blocks: editItem.descripcion_cuadrante }
                                  : null
                              }
                              tools={EDITOR_JS_TOOLS}
                            />
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label column>Año</Form.Label>
                    <Form.Control
                      id="anio"
                      name="anio"
                      isInvalid={touched.anio && errors.anio}
                      isValid={touched.anio && !errors.anio}
                      onBlur={handleBlur("anio")}
                      onChange={handleChange}
                      value={values.anio}
                      className="rounded-pill"
                      type="number"
                      placeholder="2000"
                      min={2000}
                      disabled
                    ></Form.Control>
                    {touched.anio && !!errors.anio && (
                      <Col>
                        <small className="text-danger">{errors.anio}</small>
                      </Col>
                    )}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  {(_anio === anioActual || _anio === "") &&
                  ((!loaderMatrixNineBoxes &&
                    matrixNineBoxes &&
                    matrixNineBoxes.count < 9 &&
                    !edit) ||
                    edit) ? (
                    <Button
                      className="rounded-pill"
                      disabled={saveLoaderMatrixNineBoxes}
                      variant="primary"
                      type="submit"
                    >
                      {saveLoaderMatrixNineBoxes && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </Button>
                  ) : null}
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

function isEmptyObject(obj) {
  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      return false;
    }
  }

  return true;
}

export default Matrix;
